module.exports = __webpack_public_path__ + "static/img/layout4.47125e50.jpg";